/**
 * Frontend runtime configuration. All values come from Vite env vars
 * (prefixed VITE_) so they can be set per-environment at build time.
 */
export const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

export const TOKEN_STORAGE_KEY = 'token';
export const USER_STORAGE_KEY = 'user';

// Sign the user out after this long with no interaction (QA 7842). Minutes.
export const IDLE_TIMEOUT_MINUTES = Number(import.meta.env.VITE_IDLE_TIMEOUT_MINUTES) || 15;

// Last-interaction stamp, deliberately in localStorage so every tab shares ONE
// idle clock: without it, an idle background tab would sign out a user who is
// actively working in another tab (they share the same token).
export const ACTIVITY_STORAGE_KEY = 'afc:last-activity';

// Cross-tab announcement that an account signed in (QA 7843). Carries no token
// — only the user id — so other tabs can notice the browser's session identity
// changed underneath them.
export const SESSION_PING_KEY = 'afc:session-ping';

// Cloudflare Turnstile public site key. Empty in dev/QA and in E2E runs, where
// the widget renders nothing and the server does not enforce — the challenge
// must never become a wall the test suite has to climb.
export const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY || '';

// Why the last sign-out happened, so the login screen can explain itself.
// sessionStorage: it is this tab's business and must survive clearSession().
export const LOGOUT_REASON_KEY = 'afc:logout-reason';

// Who the tab signed out, so a `state.from` left on the /login history entry is
// only replayed for the user it belonged to (QA 7878). Carries the user id
// ONLY — never a name, email or token. sessionStorage for the same reason as
// the logout reason: it is this tab's business and must survive clearSession().
export const BOUNCED_USER_KEY = 'afc:bounced-user';
